module.exports = __webpack_public_path__ + "images/assets/75ed41757360068274ca5261822ba082.svg";